export const messages = {
  en: {
    shopTypeManage: {
      queryCondition: 'Query Conditions',
      shopType: 'Shop Type',
      inputTypeName: 'Please input type name',
      selectIsShow: 'Please select is show',
      selectIsDefault: 'Please select is default',
      yes: 'Yes',
      no: 'No',
      custom: 'Custom',
      default: 'Default',
      query: 'Query',
      add: 'Add',
      isShow: 'Is Show',
      isDefault: 'Is Default',
      seq: 'Sequence',
      serviceFee: 'Service Fee',
      remark: 'Remark',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteShopType: 'Confirm to delete shop type?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      editSuccess: 'Edit successfully',
      addSuccess: 'Add successfully',
      typeNameRequired: 'Shop type name is required',
      typeNameTooLong: 'Shop type name is too long',
      isShowRequired: 'Is show is required',
      isDefaultRequired: 'Is default is required',
      seqRequired: 'Sequence is required',
      seqNotNumber: 'Sequence must be a number',
      serviceFeeRequired: 'Service fee is required',
      inputTypeNameRequired: 'Required, please input shop type',
      selectIsShowRequired: 'Required, please select is show',
      selectIsDefaultRequired: 'Required, please select is default',
      inputSeqRequired: 'Required, please input sequence',
      inputServiceFeeRequired: 'Required, please input service fee',
      inputRemarkOptional: 'Optional, please input remark',
      selectCate: 'Please select category',
      cate: 'Category',
      supermarket: 'Supermarket',
      canteen: 'Canteen',
      service: 'Service',
      selectCateRequired: 'Category is required',
      cateRequired: 'Category is required',
      icon: 'Icon',
      noIcon: 'No Icon',
      uploadIcon: 'Upload Icon'
    }
  },
  zh: {
    shopTypeManage: {
      queryCondition: '查询条件',
      shopType: '店铺类型',
      inputTypeName: '请输入类型名称',
      selectIsShow: '请选择是否展示',
      selectIsDefault: '请选择是否默认',
      yes: '是',
      no: '否',
      custom: '自定义',
      default: '默认',
      query: '查询',
      add: '添加',
      isShow: '是否展示',
      isDefault: '是否默认',
      seq: '显示序号',
      serviceFee: '服务费',
      remark: '备注',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      confirmOperation: '请确认您的操作！',
      confirmDeleteShopType: '确定删除店铺类型？',
      cancel: '取消',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      editSuccess: '修改成功',
      addSuccess: '添加成功',
      typeNameRequired: '店铺类型不能为空',
      typeNameTooLong: '店铺类型太长',
      isShowRequired: '是否展示不能为空',
      isDefaultRequired: '是否默认不能为空',
      seqRequired: '显示序号不能为空',
      seqNotNumber: '显示序号必须是数字',
      serviceFeeRequired: '服务费不能为空',
      inputTypeNameRequired: '必填，请填写店铺类型',
      selectIsShowRequired: '必填，请选择是否展示',
      selectIsDefaultRequired: '必填，请选择是否默认',
      inputSeqRequired: '必填，请填写显示序号',
      inputServiceFeeRequired: '必填，请填写服务费',
      inputRemarkOptional: '选填，请填写备注',
      selectCate: '请选择分类',
      cate: '分类',
      supermarket: '超市',
      canteen: '食堂',
      service: '服务',
      selectCateRequired: '必填，请选择分类',
      cateRequired: '分类不能为空',
      icon: '图标',
      noIcon: '无图标',
      uploadIcon: '上传图标'
    }
  }
}